export default __webpack_public_path__ + "static/media/office2-afterB-2048w.f4c22221.png";